module.exports = __webpack_public_path__ + "static/media/DocumentsUpload.a960abce.svg";